import React, { useContext, useEffect, useMemo } from 'react';
import { /* Redirect, */ withRouter } from 'react-router-dom';

import config from '../config';
import { AuthContext } from '../contexts/auth';
import { useQuery } from '../hooks/graph';
import { addRedirect } from '../utils/misc';
import Splash from '../components/splash';

const controller = new AbortController();

function SigninOAuth({ history, location }) {
	// reserved / const { providers } = useContext(SetupContext);
	const { isAuthenticated, authenticate, token } = useContext(AuthContext);

	const searchParams = useMemo(() => {
		return new URLSearchParams(location.search);
	}, [location.search]);

	const [ { data: dataPartner } ] = useQuery('partner',
		{variables: {name: searchParams.get('partner_name')}}, controller);

	// reserved / obsoleted
	// useEffect(() => {
	// 	isAuthenticated && window.mixpanel?.track(
	// 		'OAuth process started', {distinct_id: user.id}
	// 	);
	// }, [true]);

	useEffect(() => {
		if (!searchParams.size) {
			history.push('/');
			return;
		}

		if (isAuthenticated) {
			return;
		}

		const accessToken = searchParams.get('access_token');

		if (!accessToken) {
			history.push(addRedirect('/signin', location.pathname + location.search));
			return;
		}

		// TODO what if the token is invalid? display an error message?
		authenticate(accessToken);
	}, [searchParams]);

	return isAuthenticated && dataPartner ? (
		<Splash>
			<Splash.Body>
				{/* <h3 className="text-center mb-3">Welcome to SignalStack</h3> */}

				{
					dataPartner.partner.name === 'trendspider' ? (
						<p>
							SignalStack is an order router developed by TrendSpider.
							Manual trading via SignalStack is free, forever.
						</p>
					) : (
						false
					)
				}

				<h3 className="text-center mb-3">
					{dataPartner.partner.title || 'The application'} would like to:
				</h3>

				<ul className="mt-4">
					<li>Read list of brokerage accounts connected</li>
					<li>Submit orders to any of them by your request</li>
					<li>Obtain list of holdings from any of them by your request</li>
				</ul>

				<form
					method="post"
					action={config.server.base + '/api/oauth/authorize' + location.search}
					className="mt-4"
				>
					<input type="hidden" name="access_token" value={token} />
					<button type="submit" className="btn btn-primary w-100">
						Grant access
					</button>
				</form>

				{/*
				<p>
					Connect your
					{ providers[searchParams.get('provider_name')]?.title ?? ' broker ' }
					account to SignalStack in order to trade from TrendSpider,
					either manually or automatically.
				</p>
				*/}
			</Splash.Body>

			{
				<div className="mt-4 text-center text-secondary">
					Something wrong? <span><a href="mailto:hello@signalstack.com">Contact support</a> for help.</span>
				</div>
			}
		</Splash>
	) : false;
}

export default withRouter(SigninOAuth);
